// extracted by mini-css-extract-plugin
export default {"cardGroupsContainer":"TrendingSubCategories_cardGroupsContainer__-W5-j"};